"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTS006_List = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const AttachContentButton_1 = require("./DSTS006_List_Child/AttachContentButton");
const ContentTab_1 = require("./DSTS006_List_Child/ContentTab");
const ContentTable_1 = require("./DSTS006_List_Child/ContentTable");
const DSTS006ListStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	flex: 1;

	.regist_btn {
		position: fixed;
		right: ${props => (props.$isMobile ? '26px' : props.$isTablet ? '46px' : '62px')};
		bottom: ${props => (props.$isDesktop ? '55px' : '139px')};
		overflow: visible;

		.button {
			width: 48px;
			height: 48px;
		}

		.attach-field {
			display: flex;
			flex-direction: row;
			width: 100%;
			gap: 15px;
		}
	}
`;
exports.DSTS006_List = react_1.default.memo(() => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [menu, setMenu] = (0, react_1.useState)('document');
    return (react_1.default.createElement(DSTS006ListStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet, className: "contents-list" },
        react_1.default.createElement(ContentTab_1.ContentTab, { menu: menu, setMenu: setMenu }),
        react_1.default.createElement(ContentTable_1.ContentTable, { menu: menu }),
        react_1.default.createElement(AttachContentButton_1.AttachContentButton, { menu: menu })));
});
